// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"7a951c55","297":"a392ad0c","474":"b7ccfcc7","643":"8ef42d7a"}[chunkId] + ".chunk.js";
};